// フォント設定画面
import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Container } from '@material-ui/core';

import { FontType } from '../redux/cardAttributeModelIndex';
import { initial } from '../card_components/index';
import EditItemFont from './EditItemFont';

type DrawTextFontDialogProps = {
  open: boolean;
  onClose: () => void;
  fontValue: FontType;
  changeFont: (font: FontType) => void;
}
const DrawTextFontDialog: React.FC<DrawTextFontDialogProps> = ({open, onClose, fontValue, changeFont}) => {
  const [font, setFont] = useState<FontType>(initial.font);

  useEffect(() => setFont(fontValue), [fontValue])

  const fontUpdate = () => {
    changeFont(font);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
      <DialogTitle>テキストのFont設定</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <Container>
          <EditItemFont kind="drawText" font={font} setFont={setFont} />
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
        <Button variant="text" color="primary" onClick={fontUpdate}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DrawTextFontDialog;
